import { Controller } from "react-hook-form";
import Select from "@/components/Select";
import HtmlRichTextEditor from "@/components/RichTextEditor/HtmlRichTextEditor";

export function EducationAndExperienceStep({ form }: { form: any }) {
  const {
    control,
    clearErrors,
    trigger,
    formState: { errors }
  } = form;

  const YEARS_OF_EXPERIENCE_OPTIONS = [
    { value: "0", label: "Not Applicable" },
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
    { value: "5", label: "5+" }
  ];

  const EDUCATION_OPTIONS = [
    { value: "N/A", label: "Not Applicable" },
    { value: "High School Graduate", label: "High School Graduate" },
    { value: "GED", label: "GED" },
    { value: "Vocational Qualification", label: "Vocational Qualification" },
    { value: "Bachelors", label: "Bachelors" },
    { value: "Masters", label: "Masters" },
    { value: "Doctorate or Higher", label: "Doctorate or Higher" }
  ];

  const PGA_LEARNING_OPTIONS = [
    { value: "N/A", label: "Not Applicable" },
    { value: "PGA Specialized Professional", label: "PGA Specialized Professional" },
    { value: "PGA Certified Professional", label: "PGA Certified Professional" },
    { value: "PGA Master Professional", label: "PGA Master Professional" }
  ];

  return (
    <div className="space-y-6">
      <div className="text-headline-small">Enter education information and essential responsibilities for the job.</div>

      <div className="col-span-full">
        <Controller
          name="requiredExperienceInYears"
          control={control}
          rules={{ required: "Years of experience is required" }}
          render={({ field: { onChange, value } }) => (
            <Select
              label="Years of Experience"
              options={YEARS_OF_EXPERIENCE_OPTIONS}
              className="w-full"
              value={value}
              required
              error={!!errors.requiredExperienceInYears}
              errorText={errors.requiredExperienceInYears?.message as string}
              onSelect={(value) => {
                onChange(value);
                if (value && errors.requiredExperienceInYears) {
                  clearErrors("requiredExperienceInYears");
                }
                if (!value) {
                  trigger("requiredExperienceInYears");
                }
              }}
            />
          )}
        />
      </div>
      <div className="col-span-full">
        <Controller
          name="requiredEducation"
          control={control}
          rules={{ required: "Education is required" }}
          render={({ field: { onChange, value } }) => (
            <Select
              label="Education"
              options={EDUCATION_OPTIONS}
              className="w-full"
              value={value}
              required
              error={!!errors.requiredEducation}
              errorText={errors.requiredEducation?.message as string}
              onSelect={(value) => {
                onChange(value);
                if (value && errors.requiredEducation) {
                  clearErrors("requiredEducation");
                }
                if (!value) {
                  trigger("requiredEducation");
                }
              }}
            />
          )}
        />
      </div>
      <div className="col-span-full">
        <Controller
          name="additionalPgaEducation"
          control={control}
          rules={{ required: "PGA Learning is required" }}
          render={({ field: { onChange, value } }) => (
            <Select
              label="PGA Learning"
              options={PGA_LEARNING_OPTIONS}
              className="w-full"
              value={value}
              required
              error={!!errors.additionalPgaEducation}
              errorText={errors.additionalPgaEducation?.message as string}
              onSelect={(value) => {
                onChange(value);
                if (value && errors.additionalPgaEducation) {
                  clearErrors("additionalPgaEducation");
                }
                if (!value) {
                  trigger("additionalPgaEducation");
                }
              }}
            />
          )}
        />
      </div>
      <div className="col-span-full">
        <Controller
          name="requiredExperienceDescription"
          control={control}
          render={({ field: { onChange, value } }) => (
            <HtmlRichTextEditor
              initialContent={value}
              label="Experience Required"
              placeholder="Description"
              onChange={onChange}
            />
          )}
        />
      </div>
      <div className="col-span-full">
        <Controller
          name="essentialResponsibilities"
          control={control}
          render={({ field: { onChange, value } }) => (
            <HtmlRichTextEditor
              initialContent={value}
              label="Essential Responsibilities"
              placeholder="Description"
              onChange={onChange}
            />
          )}
        />
      </div>
    </div>
  );
}
